import { createContext } from 'react';
import { IconThemeContextValue } from './WixDesignSystemIconThemeProvider.types';

export const IconThemeContext = createContext<IconThemeContextValue>({
  icons: {},
});
